"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from "react";
import RainforestPaymentMethod from "@/components/rainforest/rainforest-payment-method";
import { DeclineAudience, normalizeDecline } from "@/lib/payments/decline-reason";
import { cx } from "@/lib/tailwind-utils";
import { PaymentProcessor } from "@/types/auth";
import { RainforestPaymentMethodConfig } from "@/types/rainforest";
interface RainforestSavePaymentMethodProps {
  /** Who reads the failure. See `StripeSaveMethodSurface`; same contract. */
  audience?: DeclineAudience;
  paymentMethodConfig: RainforestPaymentMethodConfig;
  onSuccess: (event: any) => void;
  onFailure: (err: string) => void;
  onValid: (event: any) => void;
  onInvalid: (event: any) => void;
  onMethodUpdated?: (event: any) => void;
  className?: string;
  hideButton?: boolean;
  fontSize?: string;
  allowedMethods?: string;
  styleOverrides?: {
    buttonColor?: string;
    borderColor?: string;
    borderRadius?: string;
    borderWidth?: string;
    iconColor?: string;
    errorBorderColor?: string;
    errorMessageColor?: string;
  };
}
export const RainforestSavePaymentMethod: React.FC<RainforestSavePaymentMethodProps> = t0 => {
  const $ = _c(22);
  const {
    audience,
    onSuccess,
    onFailure,
    onValid,
    onInvalid,
    onMethodUpdated,
    paymentMethodConfig,
    className,
    hideButton: t1,
    fontSize: t2,
    allowedMethods,
    styleOverrides
  } = t0;
  const hideButton = t1 === undefined ? true : t1;
  const fontSize = t2 === undefined ? "14px" : t2;
  let t3;
  if ($[0] !== audience || $[1] !== onFailure) {
    t3 = event => {
      onFailure(normalizeDecline(PaymentProcessor.RAINFOREST, event, audience, "save").message);
    };
    $[0] = audience;
    $[1] = onFailure;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleDeclined = t3;
  let t4;
  if ($[3] !== onFailure) {
    t4 = () => {
      onFailure("An error occurred while processing the payment method. Please try again later.");
    };
    $[3] = onFailure;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleError = t4;
  let t5;
  if ($[5] !== className) {
    t5 = cx("pt-4", className);
    $[5] = className;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== allowedMethods || $[8] !== fontSize || $[9] !== handleDeclined || $[10] !== handleError || $[11] !== hideButton || $[12] !== onInvalid || $[13] !== onMethodUpdated || $[14] !== onSuccess || $[15] !== onValid || $[16] !== paymentMethodConfig || $[17] !== styleOverrides) {
    t6 = <RainforestPaymentMethod paymentMethodConfig={paymentMethodConfig} handleApproved={onSuccess} handleDeclined={handleDeclined} handleError={handleError} handleValid={onValid} handleInvalid={onInvalid} handleMethodUpdated={onMethodUpdated} hideButton={hideButton} fontSize={fontSize} allowedMethods={allowedMethods} styleOverrides={styleOverrides} />;
    $[7] = allowedMethods;
    $[8] = fontSize;
    $[9] = handleDeclined;
    $[10] = handleError;
    $[11] = hideButton;
    $[12] = onInvalid;
    $[13] = onMethodUpdated;
    $[14] = onSuccess;
    $[15] = onValid;
    $[16] = paymentMethodConfig;
    $[17] = styleOverrides;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5 || $[20] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
export default RainforestSavePaymentMethod;